import '@mdi/font/css/materialdesignicons.css'

import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
          light: {
            theme1:"#424093",
            theme2:"#ffb500",
            headerColor:'#252425', /* old #605ca8 */
            sidebarColor: '#ffffff', /* old #222d32 */
            sidebarTextColor: '#b8c7ce',
            primary: '#424093',  /* #3f51b5 */
            secondary: '#b0bec5',
            accent: '#8c9eff',
            error: '#b71c1c',//red
            success: '#4caf50',
            info: "#5cbbf6",
            default: "#e0e0e0",
            green:"#4CAF50",
            warning: "#ff9800",
            pink: "#e91e63",
            teal: "#00bcd4",
            lightgreen: "#92c755",
            
            colorAAAAAA:"#AAAAAA",
            colorBDBDBD:"#BDBDBD",
            colorCCCCCC:"#CCCCCC",
            colorC0C0C5:"#C0C0C5",
            colorC1C1C1:"#C1C1C1",
            colorC6CDDB:"#C6CDDB",
            colorDC3545:"#DC3545", // disabled red color
            colorDBDBDB:"#DBDBDB",
            colorECEAEA:"#ECEAEA",
            colorE4E1E1:"#E4E1E1",
            colorE8E8E8:"#E8E8E8",
            colorF0F0F0:"#F0F0F0",
            colorF7F7F7:"#F7F7F7",
            colorF1ECF0:"#F1ECF0",
            colorF81C41:"#F81C41", // red color
            colorF9F8F8:"#F9F8F8",

            color03A685:"#03A685",
            color2B2B2B:"#2B2B2B",
            color2D4356:"#2D4356",
            color2F2F2F:"#2F2F2F",
            color252425:"#252425",
            color26B1B1:"#26B1B1", //logo T letter color
            color333333:"#333333",
            color424093:"#424093",
            color555555:"#555555",
            color707070:"#707070",
            color71B9C8:"#71B9C8", 
            color737373:"#737373",
            color777777:"#777777",
            color999999:"#999999",
            
          },
        },
      },
      icons: {
        iconfont: 'mdi', // default - only for display purposes
      },
});
